// TODO revisit permission management, implement normal architecture instead
export const ACCESS_TYPE_PROVIDER = 1
export const ACCESS_TYPE_PATIENT_LIST = 2
export const ACCESS_TYPE_HOME_CARE = 3
export const ACCESS_TYPE_PAYER_USER = 4

export const PATIENT_SEARCH_ACCESS = [
  ACCESS_TYPE_PROVIDER,
  ACCESS_TYPE_PATIENT_LIST,
  ACCESS_TYPE_HOME_CARE,
  ACCESS_TYPE_PAYER_USER
]
export const PATIENT_PAYER_ACCESS = [ACCESS_TYPE_PAYER_USER]

export const ACTION_CAREGAP_ACCESS = [ACCESS_TYPE_PAYER_USER]
